import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="py-12 text-center text-cream-300 text-sm bg-dark-900 border-t border-dark-800" data-id="element-56">
        <p className="mb-4" data-id="element-57">
          © 2026 Minerales de Sangre. Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-6" data-id="element-58">
          <button onClick={() => setActiveModal('privacy')} className="text-cream-400 hover:text-gold-500 transition-colors underline decoration-cream-400/30 underline-offset-4" data-id="element-59">
            Privacy Policy
          </button>
          <button onClick={() => setActiveModal('terms')} className="text-cream-400 hover:text-gold-500 transition-colors underline decoration-cream-400/30 underline-offset-4" data-id="element-60">
            Terms of Service
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-61">
        {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-62">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeModal} className="absolute inset-0 bg-dark-900/90 backdrop-blur-sm" data-id="element-63" />

            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative bg-dark-800 border border-dark-700 w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-lg shadow-2xl p-8 text-cream-200" data-id="element-64">
              <button onClick={closeModal} className="absolute top-4 right-4 text-dark-400 hover:text-cream-100 transition-colors" data-id="element-65">
                <XIcon className="w-6 h-6" data-id="element-66" />
              </button>

              {activeModal === 'privacy' && <div className="prose prose-invert prose-sm max-w-none" data-id="element-67">
                  <h2 className="text-2xl font-serif text-gold-400 mb-6" data-id="element-68">
                    Privacy Policy
                  </h2>
                  <p data-id="element-69">Last updated: February 2026</p>
                  <p data-id="element-70">
                    We respect your privacy and are committed to protecting your
                    personal data. This privacy policy will inform you as to how
                    we look after your personal data when you visit our website
                    and tell you about your privacy rights and how the law
                    protects you.
                  </p>
                  <h3 data-id="element-71">1. Information We Collect</h3>
                  <p data-id="element-72">
                    We may collect, use, store and transfer different kinds of
                    personal data about you which we have grouped together
                    follows: Identity Data, Contact Data, Technical Data, Usage
                    Data.
                  </p>
                  <h3 data-id="element-73">2. How We Use Your Data</h3>
                  <p data-id="element-74">
                    We will only use your personal data when the law allows us
                    to. Most commonly, we will use your personal data in the
                    following circumstances: Where we need to perform the
                    contract we are about to enter into or have entered into
                    with you.
                  </p>
                  <h3 data-id="element-75">3. Data Security</h3>
                  <p data-id="element-76">
                    We have put in place appropriate security measures to
                    prevent your personal data from being accidentally lost,
                    used or accessed in an unauthorized way, altered or
                    disclosed.
                  </p>
                </div>}

              {activeModal === 'terms' && <div className="prose prose-invert prose-sm max-w-none" data-id="element-77">
                  <h2 className="text-2xl font-serif text-gold-400 mb-6" data-id="element-78">
                    Terms of Service
                  </h2>
                  <p data-id="element-79">Last updated: February 2026</p>
                  <p data-id="element-80">
                    Please read these Terms of Service carefully before using
                    our website operated by Minerales de Sangre.
                  </p>
                  <h3 data-id="element-81">1. Conditions of Use</h3>
                  <p data-id="element-82">
                    By using this website, you certify that you have read and
                    reviewed this Agreement and that you agree to comply with
                    its terms. If you do not want to be bound by the terms of
                    this Agreement, you are advised to leave the website
                    accordingly.
                  </p>
                  <h3 data-id="element-83">2. Intellectual Property</h3>
                  <p data-id="element-84">
                    You agree that all materials, products, and services
                    provided on this website are the property of Minerales de
                    Sangre, its affiliates, directors, officers, employees,
                    agents, suppliers, or licensors including all copyrights,
                    trade secrets, trademarks, patents, and other intellectual
                    property.
                  </p>
                  <h3 data-id="element-85">3. User Accounts</h3>
                  <p data-id="element-86">
                    As a user of this website, you may be asked to register with
                    us and provide private information. You are responsible for
                    ensuring the accuracy of this information, and you are
                    responsible for maintaining the safety and security of your
                    identifying information.
                  </p>
                </div>}
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}